export class DeclarationLotsLabellises {
    static jsonMap = {
        id: { key: 'id', optional: true },
        numeroLot: { key: 'numeroLot', optional: true, default: '' },
        millesime: { key: 'millesime', optional: true, default: '' },
        produit: { key: 'produit', optional: true, default: '' },
        cepage: { key: 'cepage', optional: true },
        volume: { key: 'volume', optional: true, default: '' },
        logement: { key: 'logement', optional: true, default: '' }
    };

    id: number;
    numeroLot: string;
    millesime: string;
    produit: string;
    cepage: number;
    volume: string;
    logement: string;
}
